import Enum from './enum'

class BidState extends Enum
{
  constructor(value) {
    super(value);
  }
}

BidState.init({
  NONE: 'None',
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
  DECLINED: 'Declined',
  ACCEPTED: 'Accepted'
}, {
  NONE: 'bid-state.none',
  ACTIVE: 'bid-state.active',
  SUSPENDED: 'bid-state.suspended',
  DECLINED: 'bid-state.declined',
  ACCEPTED: 'bid-state.accepted'
});

export default BidState;
